module.exports = "<div class=\"parameter\">\n    <h4>{{toolName}}</h4>\n</div>"